import { Role } from "@idha/idha-types";
import { utilsModule } from "../utils-module";

utilsModule.factory('rolesService', ['LoggedUserService',function (LoggedUserService) {

    var permissions = undefined;

    return {
        hasRole : function(role:string){
            //O controle aparenta ser facil de burlar. Mas se trata apenas de frontend
            //Todo o controle pesado de roles está no servidor. Burlar este acesso mexendo
            //diretamente no localstorage provocará uma série de erros 401
            if(!LoggedUserService.loggedUser || !LoggedUserService.loggedUser.roles) return false;
            return (LoggedUserService.loggedUser.roles.find((_role:Role)=>{
                return _role.name == role
            })) !== undefined;
        }
    }
}])